import React from 'react';

class FileIcon extends React.Component {
  render() {
    let fileClass = 'fa-file-o';

    switch (this.props.contentType) {
      case 'application/msword':
        fileClass = 'fa-file-doc-o';
        break;
      case 'application/vnd.ms-excel':
        fileClass = 'fa-file-excel-o';
        break;
      case 'application/pdf':
        fileClass = 'fa-file-pdf-o';
        break;
      case 'video/mp4':
      case 'video/webm':
      case 'video/ogg':
        fileClass = 'fa-file-video-o';
        break;
      case 'image/png':
      case 'image/jpeg':
        fileClass = 'fa-file-image-o';
        break;
      default:
        fileClass = 'fa-file-o';
        break;
    }

    return (
      <i className={`fa ${fileClass} ${this.props.className}`}></i>
    );
  }
}

FileIcon.defaultProps = {
  className: '',
  contentType: null
};

export default FileIcon;
